import React from "react";
import { useLocation, useNavigate, generatePath } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Paths } from "@/src/constants/Paths";
import { slugify } from "../../helpers/commonHelper";

const FALLBACK_IMG = "https://placehold.co/600x400?text=Destination";

function truncate(text, max = 120) {
  const t = (text ?? "").toString().trim();
  if (!t) return "";
  return t.length > max ? t.slice(0, max - 1) + "…" : t;
}

export default function PopularDestinationListItem({ destination }) {
  const navigate = useNavigate();
  const { search } = useLocation();

  const name = destination?.DestinationName || "Untitled destination";
  const img = destination?.ImageUrl?.trim() || FALLBACK_IMG;
  const desc = truncate(destination?.Description, 130);

  const goToDetail = () => {
    navigate(
      {
        pathname: generatePath(Paths.TOUR_DESTINATION_DETAIL, {
          destinationId: destination?.DestinationID,
          destinationName: slugify(destination?.DestinationName || "destination"),
        }),
        search: search,
      },
      {
        state: {
          destination, // pass header data for instant render
        },
      }
    );
  };

  return (
    <div
      role="button"
      tabIndex="0"
      onClick={goToDetail}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          goToDetail();
        }
      }}
      className="text-left w-full cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-xl"
      aria-label={`Open destination ${name}`}
    >
      <div className="group overflow-hidden rounded-xl border bg-card shadow-sm hover:shadow-md transition-shadow">
        <div className="h-44 w-full bg-muted overflow-hidden">
          <img
            src={img}
            alt={name}
            className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-[1.03]"
            onError={(e) => {
              e.currentTarget.src = FALLBACK_IMG;
            }}
            loading="lazy"
          />
        </div>

        <div className="p-4 space-y-3">
          <div className="space-y-1">
            <h3 className="text-base font-semibold leading-tight line-clamp-1">
              {name}
            </h3>

            {desc ? (
              <p className="text-sm text-muted-foreground line-clamp-3">
                {desc}
              </p>
            ) : null}
          </div>

          <div className="flex items-center justify-between">
            <span className="text-sm font-medium text-primary group-hover:underline">
              Explore packages
            </span>
            <Button size="sm" variant="secondary" onClick={(e) => { e.stopPropagation(); goToDetail(); }}>
              View
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
